<template>
<div class="chapter">
<div class="inner_page">
<p class="center">Copyright © 2009 by Peter Murphy</p>
<p class="timebreak"> <br/></p>
<p class="center">First published in 2009 by Faber and Faber Limited, London</p>
<p class="timebreak"> <br/></p>
<p class="center"><span style="font-size: smaller">ALL RIGHTS RESERVED</span></p>
<p class="timebreak"> <br/></p>
<p class="center">For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.</p>
<p class="timebreak"> <br/></p>
<p class="center"><a href="http://www.hmhbooks.com" target="_blank">www.hmhbooks.com</a></p>
<p class="timebreak"> <br/></p>
<p class="center"><em>The Library of Congress has cataloged the print edition as follows:</em><br/>
Murphy, Peter, date.<br/>
John the revelator / Peter Murphy.<br/>
p. cm.<br/>
<span style="font-size: smaller">ISBN</span> 978-0-15-101402-6<br/>
1. Boys—Fiction. 2. Single mothers—Fiction. 3. Mothers and sons—Fiction. 4. Adolescence—Fiction. 5. City and town life—Ireland—Fiction. 6. Ireland—Fiction. 7. Psychological fiction. 8. Domestic fiction. I. Title.<br/>
<span style="font-size: smaller">PR</span>6113.<span style="font-size: smaller">U</span>773<span style="font-size: smaller">J</span>65 2009<br/>
823'.92—dc22 2008043414</p>
<p class="timebreak"> <br/></p>
<p class="center">e<span style="font-size: smaller">ISBN</span> 978-0-547-39392-6<br/>
v4.0813</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?29936b60